// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"903":"221e8780","970":"51ad3fb9"}[chunkId] + ".css";
};